export default {
  tms: {

  },
  generic: {
    Home:"Home",
    ReporMaster: "Report Master",
    GenericName: "Generic Name",
    ModuleCode: "Module Code",
    Description: "Description",
    FunctionCode: "Function Code",
    PageTitleCode: "Page Title Code",
    IsPaging: "Is Paging",
    IgnoreCount: "Previous/Next Page",
    Creator: "Creator",
    CreateDate: "Create Date",
    Modifier: "Modifier",
    ModifyDate: "Modify Date",
    GMCUID: "GMC UID",
    SCHEMAUID: "SCHEMA UID",
    UIAction: "UI Action",
    Validation: "Validation",
    Editable: "Edit",
    EditCondition:"Edit Condition",
    Searchable: "Search",
    DefaultValue: "DefaultValue",
    Madatory: "Madatory",
    Displayable: "Display",
    Sequence: "Sequence",
    Condition: "Condition",
    Mandatory: "Mandatory",
    AndOr: "And/Or",
    GCDUID: "GCD UID",
    ParentGCDUID: "Parent GCD UID",
    IfOrNotMove:"Whether to move?",
    TableName: "Table Name",
    EnglishName: "English Name",
    CnName: "Cn Name",
    TraditionalCNName: "Traditional Cn Name",
    KorName: "Kor Name",
    thName: "Th Name",
    jpName: "Japen Name",
    Header: "Header",
    TableAlias: "Table Alias",
    FieldName: "Field Name",
    FieldType: "Field Type",
    FieldLength: "Field Length",
    FieldLengthDecimal: "Field Length Decimal",
    ForeignTable: "Foreign Table",
    ForeignFIELD: "Foreign FIELD",
    LanguageCode: "Language Code",
    Module: "Module",
    SubPage: "Sub Page",
    SubModule: "Sub Module",
    Function: "Function",
    PageTitle: "Page Title",
    Decimal: "Decimal",
    Edit: "Edit",
    Add: "Add",
    More: "More",
    AreyoudeleTask: "Are you sure delete selected record(s)?",
    Yes: "Yes",
    No: "No",
    Delete: "Delete",
    Zip: "Zip",
    Up: "Up",
    Down: "Down",
    Store: "Store",
    ButtonGroupName: "Button Group Name",
    Apply: "Apply",
    Configuration: "Configuration",
    Name: "Name",
    RenderType: "Render Type",
    Type: "Type",
    Code: "Code",
    ViewType: "View Type",
    PatternType: "Pattern Type",
    ExtenalAPI: "External API",
    MapToModule: "Map To Module",
    FieldMap: "Field Map",
    BehaviorPattern: "Behavior Pattern",
    Parameters: "Parameters",
    CustPage: "CustPage",
    Action: "Action",
    Width: "Width",
    ConsParameter: "Cons. Parameter",
    Constrainttable: "Constraint table",
    Seq: "Seq",
    ValidationSQL: "ValidationSQL",
    operate: "Operate",
    Group: "Group",
    FKTable: "FKTable",
    FKFieldName: "FK Field Name",
    SQLParameters: "SQL Parameters",
    defaultValue: "Default Value",
    DisplayColumns: "Display Columns",
    SortSeq: "Sort Seq",
    OrderBy: "Order By",
    Refresh: "Refresh",
    PagePropertyGroupName: "Page Property Group Name",
    Disaplyable: "Display",
    Like: "Like",
    IsShowTitle: "Is Title",
    ShowTitleSeq: "ShowTitleSeq",
    OptionType: "Option Type",
    ExtentionValue: "Extention Value",
    GenIdtype: "Gen Id type",
    Hyperlink: "Hyperlink",
    Isitunique: "Is it unique",
    Statistics: "Statistics",
    DataFormat: "Data Format",
    FieldPattern: "Field Pattern",
    GenericParameters: "Generic Parameters",
    DefaultSelected: "Default Selected",
    IsReserveAdmin: "Is Reserve Admin",
    TitleInfo: "Title Info",
    UniqueParameter: "Unique Parameter",
    Depend: "Depend",
    IsDefType: "IsDefType",
    ConfigurationMethod: "Configuration calculation method",
    CalcParameters: "Calc Parameters",
    CalcType: "Calc Type",
    SurfixParameter: "Surfix Parameter",
    ComputationalEvent: "Computational event",
    TriggerFields: "Trigger Fields",
    IsTrigger: "Is Trigger",
    Publish: "Publish",
    AdvanceSearch: "Advance Search",
    SearchTemplate: "Filter Template",
    IsDefault: "Is Default",
    Loadable: "Loadable",
    IsExtra: "Is Extra",
    ExtraParameters: "Extra Parameters",
    TemplateName: "Template Name",
    CreateTime: "Create Time",
    Copy: "Copy",
    CreateGenericData: "Create Generic Data",
    AppendGenericData: "Append Generic Data",
    DeleteGenericData: "Delete Generic Data",
    PleasemoduleonlyGeneric: "Please make sure one module only one startup generic",
    DBSchema: "DB Schema",
    PageProperty: "Page Property",
    SQL: "SQL",
    ConfigSQL: "Config SQL",
    Behavior: "Behavior",
    ForOption: "For Option",
    StartupModule: "Startup Module",
    UseViewSQL:"Use View SQL",
    ReportView: "Report View",
    TableViewName: "Table/View Name",
    FiledName: "Filed Name",
    Basic: "Basic",
    AliasName: "Alias Name",
    SubModuleCode: "Sub Module Code",
    SubModuleName: "Sub Module Name",
    FunctionName: "Function Name",
    FunctionLevel: "Function Level",
    ParentFunctionCode: "Parent Function Code",
    FunctionSeq: "Function Seq",
    FunctionURL: "Function URL",
    LangCode: "Lang Code",
    Menu: "Menu",
    GenericMenu: "Generic Menu",
    RelationTable: "Relation Table",
    UserMenu: "User Menu",
    FunctionAPI: "Function API",
    Status: "Status",
    NotInactive: "Not allow to publish since generic already published or inactive",
    Mapto: "Map to",
    Project: "Project",
    Usage: "Usage",
    Source: "Source",
    TargetTo: "Target To",
    ExcelType: "ExcelType",
    OnlyAllowLetter: "Only allow input letter",
    Export: "Export",
    SourceMap: "Source Map",
    MapToView: "Map To View",
    TargetMap: "Target Map",
    Excel: "Excel",
    SelectedMatched: "Selected fields need to be matched.",
    DataDuplication: "Data duplication",
    UnUploadFile: "Please upload file!",
    isShowCopy:"Copy",
    copySuccess:"Copy Success",
    totalOf:"Total of ",
    Records:"Records",
  },
  userlang: {
    Address1: "Address1",
    Address2: "Address2",
    Address3: "Address3",
    Address4: "Address4",
    Postal: "Postal",
    Street: "Street",
    District: "District",
    Latitude: "Latitude",
    Longitude: "Longitude",
    Country: "Country",
    Enable: "Enable",
    Disable: "Disable",
    Empower: "Empower",
    Edit: "Edit",
    EditUser: "Edit User",
    UserAccount: "User Account",
    LoginAccount: "Login Account",
    DispName:"Display Name",
    Email: "Email",
    EmailInfoFrom: "The input is not valid E-mail!",
    FirstName: "First Name",
    MiddleName: "Middle Name",
    LastName: "Last Name",
    DisplayName: "Display Name",
    Title: "Title",
    Gender: "Gender",
    Male: "Male",
    Female: "Female",
    Company: "Company",
    Department: "Department",
    Position: "Position",
    Telephone: "Telephone",
    City: "City",
    SelectCity: "Please select City",
    TimeZone: "TimeZone",
    Language: "Language",
    english:"English",
    Jtlang: "Simplified Chinese",
    ftlang: "Traditional Chinese",
    englishName:"English Name",
    sumplifiedName:"Simplified Name",
    traditionalName:"Traditional Name",
    koreanName:"Korean Name",
    japaneseName:"Japanese Name",
    thaiName:"Thai Name",
    korlang: "한국어",
    thlang: "ภาษาไทย",
    jplang: "日本語",
    Orgnization: "Orgnization",
    Project: "Project",
    Delete: "Delete",
    NorecordFound: "No record found !",
    Organization: "Organization",
    Warehouse: "Warehouse",
    Address: "Address",
    Save: "Save",
    AccessRights: "Access Rights",
    Pleaseselect: "Please select",
    Role: "Role",
    PleaseOneleast: "Please select one record at least.",
    SaveSuccessfully: "Save successfully",
    AddProject: "Add Project",
    AddWarehouse: "Add Warehouse",
    defaultOrg:"Default Orgnization",
    defaultProj:"Default Project",
    domain:"Domain",
    useredQr:"2FA User QR"
  },
  convertCountResult: {
    title: "Convert Count Result",
    filenameStartFrom: "Filename start from",
    importSuccess: "Import Success",
    pleaseUpload: "Please upload a file",
    noFileToDownload: "No file available to download",
    invalidFilename: "Filename start from must be 2, S or Q",
    invalidFileType: "Only .xlsx files are supported"
  },
  publicLang: {
    DeleteSuccess: "Delete Success",
    HelpMessage: "Help",
    PreviousPage: "Previous",
    NextPage: "Next",
    Page: "Page",
    CourierNumberIsNotNull: "Courier number cannot be empty.",
    CourierNumber:"Courier number",
    InputRequiredValue: "Please input the required items first!",
    containerIdNotExists: "carton Not Exists or carton had Rec",
    CartonIdNumNotExists: "carton Not Exists or carton had Rec",
    PleaseOneLeast: "Please select one at least.",
    AreUpadte: "Are you sure update selected record(s)?",
    NotAllowtodeleteCancel: "Not allow to delete/cancel",
    Notprintfirst: "Not allow to print, please do allocation first.",
    Notprintpackfirst: "Not allow to print, please do scan pack first.",
    ProjectandWarehouse: "Project and Warehouse",
    AlertMessage: "Alert Message",
    NewTemplateName: "New Template Name",
    ProjectTemplate: "Project Template",
    StyleSetting: "Style Setting",
    NavigationMode: "Navigation Mode",
    LeftLayout: "Left Side Menu Layout",
    TopLayout: "Top Side Menu Layout",
    Arecancel: "Are you sure to cancel?",
    Areconfirm: "Are you sure to confirm?",
    Yes: "Yes",
    No: "No",
    SKUSearch: "SKU Search",
    StatusNotNew:"Order status can not be New",
    PubOk: "OK",
    theIstAdministrator: "The account isn't granted access rights yet, please contact administrator.",
    PleaseSltAtleast: "Please select one record at least!",
    ColumnSearchRequired: "Please set at least one query condition before loading.",
    PleaseCheckDisplayableFirst: "Please check displayable first!",
    pleaseOneOnly: "Please select one record only",
    SelectRestrict: "The selected data cannot be greater than 100",
    PleaseFirst: "Please select one record first.",
    DraglistSort: "Drag the list to sort",
    CreatTime: "CreatTime",
    Clear: "Clear",
    Save: "Save",
    UpdateSuccess: "Update success",
    PasswordUpdatedSuccessfully: "Password updated successfully!",
    Project: "Project",
    PleaseSelect: "Please Select",
    Required: "Required",
    ThenotEmail: "The input is not valid E-mail",
    PleaseEnter: "Please enter",
    PleaseMobileNumberCorrectly: "Please input mobile number correctly",
    RequireNumerFormat: "Require numeric format",
    SystemAdministrator: "System configuration issue, please contact administrator.",
    Download: "Download",
    Preview: "Preview",
    Wrongconfiguration: "Wrong configuration",
    NotAllowToOverReceive: "Not allow to over receive",
    Search: "Search",
    Close: "Close",
    sendEdi: "Send Edi",
    rePrint: "Re-print",
    Cancel: "Cancel",
    Confirm: "Confirm",
    CheckComplete: "Check Complete",
    CancelCheckComplete: "Cancel Check Complete",
    Template: "Template",
    Loading: "Loading",
    notExistScanInList: "{0} Not exist in the scan In list",
    prompt: "prompt", // 提示
    closePrompt:"Do you confirm to close these orders",
    cancelPrompt: "Do you confirm to cancel these orders?",
    IncorrectConfiguration: "Incorrect configuration",
    NoreportFound: "No report found",
    PleaseinputEmail: "Please input your E-mail!",
    Upload: "Upload",
    UploadPhoto: "Upload Photo",
    UploadSuccess: "Upload Success!",
    DownloadCenter: "Download Center",
    FileName: "File Name",
    Action: "Action",
    overScanMsg:"{0} Not allow over receive",
    overRemoveMsg:"{0} Excessive removal is not allowed",
    locationIsNull:"Location cannot be empty",
    ConfirmShipment: "Confirm to shipment?",
    LastSKUCheckCompletePrompt:"Order is packing completed,Please Check Complete.",
    statusError:"{0} status error",
    waveIdIsNotEmpty:"{0} order already has Wave ID.",
    UploadFileOverSize:"The uploaded file exceeds the size limit, please check it.",
    UploadFailed: "Upload Failed",
    DownloadFailed: "Download Failed",
    cardNeedReplace:"Card needs to be replaced",
    NoPickedStockInContainer:"No picked stock in this Container No!",
    needToHangGooseDownGoldMedal:"Need to hang goose down gold medal",
    requestApproval:"Request Approval",
    cancelRequest:"Cancel Request",
    MustBeGreaterThanZero: "{0} must be greater than 0"
  },
  roleGe: {
    RoleLevel: "Role Level",
    ModuleName: "Module Name",
    SubModuleName: "Sub Module Name",
    Add: "Add",
    Delete: "Delete",
    Edit: "Edit",
    EditRole: "Edit Role",
    CreateRole: "Create Role",
    RoleName: "Role Name",
    RoleType: "Role Type",
    PleaseSelect: "Please Select",
    Description: "Description",
    Save: "Save",
    pleaseOneOnly: "Please select one record only",
    SaveuSccessfully: "Save successfully",
    RuleType: "Rule Type",
    RuleName: "Rule Name",
    Organization: "Organization",
    Project: "Project",
    Search: "Search",
    Creator: "Creator",
    CreateTime: "Create Time",
    Modifier: "Modifier",
    ModifiyTime: "Modifiy Time",
    Next: "Next",
    SortSubmit: "Sort Submit",
    Inventory: "Inventory",
    TableName: "Table Name",
    FieldName: "Field Name",
    InventoryFieldName: "Inventory Field Name",
    FieldType: "Field Type",
    Condition: "Condition",
    CustomizeValue: "Customize Value",
    OrderBy: "Order By",
    Operation: "Operation",
    SO: "SO",
    Rule: "Rule",
    Grouping: "Grouping",
    GroupingAndOrderBy: "Grouping and Order By",
    ReportSetting: "Report Setting",
    Import: "Import",
    Lookup: "Lookup",
    ReportName: "Report Name",
    ConfigEnableUser: "Config Enable User"
  },
  menu: {
    NotificationList: "Notification List",
    Read: "Read",
    Unread: "Unread",
    ViewMore: "View More",
    YouhaveViewedNotifications: "You have viewed all notifications",
    Receiver: "Receiver",
    ReadTime: "Read Time",
    Status: "Status",
    Subject: "Subject",
    RefType: "Ref Type",
    RefNum: "Ref Num",
    StartTime: "Start Time",
    CompleteTime: "Complete Time",
    FirstName: "First Name",
    LastName: "Last Name",
    DisplayName: "Display Name",
    MiddleName: "Middle Name",
    Email: "E-mail",
    Title: "Title",
    Gender: "Gender",
    Male: "Male",
    Female: "Female",
    Department: "Department",
    Position: "Position",
    Telephone: "Telephone",
    City: "City",
    TimeZone: "TimeZone",
    DefaultLanguage: "Default Language",
    PerformanceFeedback: "Performance Feedback",
    SimulateUser: "Simulate User",
    ReleaseUser: "Release User",
    PrintNode: "PrintNode",
    Logout: "Logout",
    NoRecordfound:"No record found !"
  },
  easyCron: {
    Specify: "Specify",
    NoSet: "No Set",
    OnlyDaysWeeksSet: "Only one of the days and weeks can be set",
    Perday: "Per day",
    Between: "Between",
    Day: "Day",
    to: "To",
    PreHour: "Pre Hour",
    Hour: "Hour",
    From: "From",
    PerMinute: "Per Minute",
    Minute: "Minute",
    PerYear: "Per Year",
    Year: "Year",
    Start: "Start",
    Expire: "Expire",
    dayWeekNoset: "Please kindly define day or week",
  },
  pubGicSet: {
    EachGroupRow: "Number of rows per order",
    SplitRec: "Split Rec",
    SelectSKU: "Select SKU",
    SelectOneSKU:"Please select a SKU",
    QuantityTypeError: "Quantity type error",
    soQty: "SO Qty",
    OrderType: "Order Type",
    SelectFieldName: "Select FieldNameSel",
    SkuDesc: "Sku Desc",
    WarehouseCode: "Warehouse Code",
    NoRecordfound: "No record found !",
    DragTheListTosort: "Drag the list to sort",
    AdvanceSearch: "Advance Search",
    AdvanceSort: "Advance Sort",
    FreezeCol: "Freeze Col",
    Clear: "Clear",
    Sort: "Sort",
    Search: "Search",
    FieldName: "Field Name",
    OrderBy: "Order By",
    Name: "Name",
    PleaseName: "Please input your name",
    SearchTemplate: "Filter Template",
    AdvanceSearcheTemplate: "Advance Searche Template",
    AreyoudeleTask: "Are you sure delete selected record(s)?",
    Yes: "Yes",
    No: "No",
    UserResetChanges: "Following action will reset any changes made for this user, do you want to continue?",
    ResetPasswordsConfirm: "The password will be reset to NULL. Please confirm if you want to proceed?",
    ResetPasswordsButton: "Reset Passwords",

    delete: "Delete",
    PleaseTamplateNameFirst: "Please select tamplate Name first",
    SaveSuccess: "Save Success",
    Mandatory: "Mandatory",
    Pleaseselect: "Please select",
    SelectPicture: " Select a picture",
    Split: "Split",
    FromValue: "From Value",
    ToValue: "To Value",
    NotAllowToSplit: "Not allow to split",
    PleaseSelectFieldName: "Please select Field Name",
    FieldAddedRepeatedly: "Field Name Cannot be added repeatedly",
    ToLocationRequired: "to Location Required",
    QtyRequired: "qty Required",
    qtyTolocatioRequired: "qty tolocation Required",
    PleaseCheckTheData: "Please check the data",
    ToValueCannotBeEmpty:"To value cannot be empty",
    RecQty: "Rec Qty",
    Location: "Location",
    ToLocation: "To Location",
    LocationISrequired: "Location is required",
    NewContainer: "New Container",
    LoadedCartonQty: "Loaded Carton Qty",
    ContainerNo: "Container No",
    SSCC: "SSCC/Tracking NO",
    trackingNo: "Tracking No",
    SSCC1: "SSCC",
    lockUpSSCC: "Lock SSCC",
    AmrContainerNo:"AMR Container",
    iWmsContainerNo:"iWMS Container",
    HiddenTable: "Hidden table",
    logisticsid: "LOGISTICSID",
    RemoveCartonFromContainer: "Remove Carton from Container",
    RelID: "Rel ID",
    PackID: "Pack ID",
    ContainerId:"Container ID",
    CartonIdNum: "Carton ID",
    DeleteCartonID:"Delete Carton ID",
    CartonIdQty:"CartonID Qty",
    CartonIdNumRegExp:"Invalid regular expression format",
    CartonIdNumFormatError:"Incorrect CTN# - {0},  please re-scan",
    ContainerIdIsEmpty:"Container ID cannot be null",
    EPC:"EPC",
    EPCIsEmpty:"EPC cannot be null",
    EPCFormatError:"EPC error,Please rescan.",
    EpcQtyMustBeOne:"EPC can only be scanned one by one",
    SSCCIsEmpty:"SSCC cannot be null",
    cartonTypeIsEmpty:"Carton Type cannot be empty",
    ConvertToReceive:"Convert to Receive",
    Carton: "Carton#",
    SKUQty: "SKU Qty",
    NewPallet: "New Pallet",
    PalletNo: "Pallet No",
    WeightPallet:"Weight Pallet",
    Length: "Length",
    InputaNumber: "Input a number",
    Width: "Width",
    Height: "Height",
    CBM: "CBM",
    Weight: "Weight",
    WeightUOM: "Weight UOM",
    LoadedPalletQty: "Loaded Pallet Qty",
    RemovePalletfromContainer: "Remove Pallet from Container",
    Remarks: "Remarks",
    Desc:"Description",
    SKU: "SKU",
    LogicalWH: "Logical WH",
    LotID: "Lot ID",
    AvailableQty: "Available Qty",
    AdjustQty: "Adjust Qty",
    ReasonCode: "Reason Code",
    Action: "Action",
    Adjust: "Adjust",
    NotEnoughInventoryToAdjust:"Not enough inventory to adjust",
    ActionCannotBeEmpty: "Action cannot be empty",
    ToLocationCannotBeEmpty: "ToLocation cannot be empty",
    ToSkuCannotBeEmpty: "ToSku cannot be empty",
    NotEnoughInventoryToMove : "Not enough inventory to move",
    DataNotChange: "The data has not changed and does not need to be saved",
    DataModifyNotSave: "The data modification is not saved",
    BatchUpdateShipment: "Batch Update Shipment",
    BathUpdate: "Bath Update",
    BatchUpdate: "Batch Update",
    ButtonConfig: "Button Config",
    ButtonConfigName: "Button Config Name",
    BePrint: "BePrint",
    ActionValue: "Action Value",
    DeAllocation: "De-allocation",
    BatchNo: "Batch No.",
    Qty: "Qty",
    originalLotId: "Orginal Lot ID",
    soLineSeq: "SO Seq. Line",
    PickLineSeq: "Pick Line Seq",
    ModifyTime: "Modify Time",
    ShipOutDate: "Ship Out Date",
    GenerateLocation: "Generate Location",
    RowName: "Row Name",
    ColumnInRow: "Column in Row",
    LevelInRow: "Level in Row",
    BinsinLocation: "Bins in Location",
    CartonToContainer: "Carton to Container",
    CartonToPallet: "Carton to Pallet",
    PalletToContainer: "Pallet to Container",
    Error: "Error",
    Lookup: "Lookup",
    PrePrintLPN: "Pre-Print LPN",
    NumberOfLPNLabelRequired: "Number of LPN Label Required",
    Print: "Print",
    ReprintLPN: "Reprint LPN",
    InnerBoxLabels: "Inner Box Labels",
    OuterCartonLabels: "Outer Carton Labels",
    Lpn:"LPN",
    Reprint: "Reprint",
    LastPrinted: "Last Printed",
    MoveLogic: "Move Logic",
    Reason:"Reason",
    FromLocation: "From Location",
    MoveQty: "Move Qty",
    ColumnName: "Column Name",
    printReportColumn: "Print Report Column",
    ScanIn: "Scan In",
    RecID: "Rec ID",
    CartonID:"Carton ID",
    TraceID:"Trace ID",
    CancelGR: "Cancel GR",
    NewGR: "New GR",
    Descr: "Descr",
    ASNQty: "ASN Qty",
    OutstandingQty: "Outstanding Qty",
    ContainerIdQty: "ContainerId Qty",
    ScanAction: "Scan Action",
    RemoveSku:"Remove",
    addSku:"Add",
    StockStatus: "Stock Status",
    LockScanQty: "Lock Scan Qty",
    LockContainer: "Delete ContainerId",
    NoofSKU: "No. of SKU",
    NoofCartonID: "No. of Carton",
    UOM: "UOM",
    ScanPack: "Scan Pack",
    WaveID: "Wave ID",
    CancelPack: "Cancel pack",
    PrintPackingList: "Print Picking List",
    PackingList: "Print Packing List",
    AllocatedQty: "Allocated Qty",
    PackedQty: "Packed Qty",
    PackedQty2: "Packed Qty",
    RemoveScanItem: "Remove Scan Item",
    IsCarton: "Is Carton",
    ScanInDirectly:"Scan In Directly",
    IsPrePack: "Is Pre-Pack",
    IsTraceId: "Is Trace Id",
    InvalidSKU: "Invalid SKU {0}.",
    NotEnoughQtyPack: "{0} Overpack is not allowed",
    NotEnoughQtyCancelPack: "{0} Not enough qty to remove",
    CartonClose:"{0} Carton is close.",
    UnpackedErrorWithEmptyCarton: "{0} Cannot be removed since carton is empty.",
    NotAllowOverPack: "{0} Not allow over pack.",
    ScanPackDecodeError:"Incorrect barcode format!",
    NotEnoughSkuRemoved: "Not enough {0} to be removed.",
    unscanpackDataNotCancel: "UnScanpack data cannot be cancelled",
    cartonQtyTooLarge: "Carton Qty quantity is too large",
    UnpackQty: "Unpack Qty",
    Detail: "Detail",
    Percentage: "Percentage",
    NoofCarton: "No. of Carton",
    Createdby: "Created by",
    CloseAndNew: "Close and New",
    New: "New",
    Remove: "Remove",
    Append: "Append",
    ImportScanningFile: "Import Scanning file",
    ImportSacnningFileGroupName: "ImportScanningFile",
    PrintSSCC: "Print SSCC",
    PrintCarton: "Print Carton",
    CartonNoSSCC: "Carton No./SSCC",
    ScannedQty: "Scanned Qty",
    CartonNo: "Carton No",
    CartonType: "Carton Type",
    DimUOM: "Dim UOM",
    GrossWeight: "Gross Weight",
    NetWeight: "NetWeight",
    PleaseNewOneCartonFirst: "Please new one carton first",
    Nosscc: "Missing SSCC, please input/scan SSCC",
    CancelTransit: "Cancel Transit",
    Transit: "Transit",
    Step: "Step",
    FromQty: "From Qty",
    ToQty: "To Qty",
    ToSku: "To SKU",
    FromSku: "From SKU",
    CourierEdi: "Courier EDI",
    IntersoftGenerateLabel: "Intersoft Generate Label",
    IntersoftCancelLabel: "Intersoft Cancel Label",
    IntersoftGenerateMainfest: "Intersoft Generate Mainfest",
    exportPackageData: "Export Package Data",
    orderCheckCompleteStartTime: "Order Check Complete Start Time",
    orderCheckCompleteEndTime: "Order check complete end time",
    whetherToPrintOnlyCompletedOrders: "Whether to print only completed orders",
    addSoToWave:"Add So to Wave",
    waveId:"Wave ID",
    ref01:"Ref 01",
    ref02:"Ref 02",
    ref03:"Ref 03",
    ref04:"Ref 04",
    ref05:"Ref 05",
    query:"Query",
    reset:"Reset",
    save:"Save",
    gift:"Gift",
    searchCartonByWave:"Search Carton by Wave",
    importSscc:"Import SSCC",
    pleaseScanAntiCode:"Please scan the anti-counterfeiting code.",
  },
  manual: {
      Manual: "Manual",
      New: "New",
      AddToPick: "Add To Pick",
      Unpick: "Unpick",
      SO: "SO#",
      Sku: "Sku",
      RecID: "Rec ID",
      BatchNo: "Batch No",
      SODate: "SO Date",
      AllQty: "All Qty/SO Qty",
      AllocateLocation: "Allocate Location",
      Status: "Status",
      LotID: "Lot ID",
      RecDate: "Rec Date",
      RecQty: "Rec Qty",
      AvailableQty: "Available Qty",
      AllocateQty: "Allocate Qty",
      ShippedQty: "Shipped Qty",
      MANUFACTUREDate: "MANUFACTURE Date",
      EXPIRYDate: "EXPIRY Date",
      SHELFDate: "SHELFDate",
      NewpickPleasego: "New a pick, please go on."
  },
  login: {
    SignAccount: "Sign in with your existing account",
    loginTitle1: "Welcome back",
    loginTitle2: "Please login to your account",
    loginTitle3: "2-Step Verification",
    loginTitle4: "This extra step shows it’s really you trying to login",
    loginTitle5:"Get a security code in a SMS message",
    loginTitle6:"This",
    loginTitle7:" may cause charges",
    loginTitle8:" on your mobile account",
    loginTitle9:"Get an email with security code",
    loginTitle10:"Security Code",
    loginTitle11:"Input Security Code",
    loginTitle12:"Trust this browser?",
    loginTitle13:"You still need your password to access the site, but you will not be asked for a security code next time you login. (for next ",
    loginTitle27:" days)",
    loginTitle14:"Get a code through an app such as",
    loginTitle15:"Google or Microsoft Authenticator",
    loginTitle16:"Set up",
    loginTitle17:"Cancel Set up",
    loginTitle18:"Install the TOTP (Time-based one-time",
    loginTitle19:"password) authenticator of your choice",
    loginTitle20:"Scan the QR Code",
    loginTitle21:"or ",
    loginTitle22:"Enter the key into your",
    loginTitle23:"authenticator app",
    loginTitle24:"Finish setup",
    loginTitle25:"Secret",
    loginTitle26:"Secret error",
    Verify: "VERIFY",
    PleaseUsername: "Please input your username!",
    Username: "Username", // user name
    Password: "Password",
    language: "Language",
    PleasePassword: "Please input your Password!",
    ForgotPassword: "Forgot Login",
    KeepIn: "Keep me signed in",
    SignIn: "Login",
    Or: "or",
    RegisterNewAccount: "Register New Account",
    NeedHelpContactAdmin: "Need help? Contact your system administrator",
    DonHaveAccount: "Don't have an account?",
    SignUPnow: "Register",
    UserPasswordError: "User name or password error",
    Cancel: "Cancel",
    Create: "Create",
    EmailAddress: "Email Address",
    VerificationCode: "Verification code",
    Pleaseverification: "Please enter the verification code",
    Sendverification: "Send verification code",
    NewPassword: "New Password",
    passWordError1: "The password must be between 8 and 64 characters.",
    passWordError2: "The password must have each of the followings:",
    passWordError3: "- a lowercase letter",
    passWordError4: "- an uppercase letter",
    passWordError5: "- a digit",
    passWordError6: "- a symbol",
    ConfirmNewPassword: "Confirm New Password",
    PleaseConfirmPassword: "Please confirm your password!",
    TwopasswordsInconsistent: "Two passwords that you enter is inconsistent!",
    RegistrationSuccess: "Registration Success", // 注册成功
    VerificationAddress: "Please click Send Verification Code",
    Submit: "Submit",
    NoUserExists: "No user exists",
    CaptchaError: "Verification code invalid",
    emailError:"Email address is invalid.",
    authenticationFailure:"authentication failure",
    SsoAccountMismatch:"The Microsoft account does not match the entered username. Please try again.",
    CaptchaVerified: "Verification successful",
    OldPassword: "Old Password",
    NewpasswordNotoldPassword: "New password not allow the same with old password",
    OriginalPasswordError: "Original password error !",
    ResetPassword: "Change Password",
    firstLoginChangePassword: "First login, please change password",
    registerForm: "Register Form",
    UserAlreadyExist: "User already exist !",
    ResetAliasName: "Change Alias Name",
    ChangeAliasName: "Change Alias Name",
    dashboardPortal:"Dashboard Portal",
    signOut:"Sign Out",
    view:"View",
    previous:"Previous",
    noReportIsSetupForThisAccount:"No report is set up for this account.",
    PasswordExpiryWarning: "Password Expiry Warning",
    PasswordExpiryMessage: "Your password is about to expire.",
    PasswordExpiredToday: "Your password expires today!",
    PasswordExpiryDaysLeft: "Your password will expire in {days} days.",
    PleaseChangePasswordImmediately: "Please change your password immediately to avoid account lockout.",
  },
  batchReceive: {
    BatchReceive: "Batch Receive",
    Query: "Query",
    Accept: "Accept",
    All: "All",
    Received: "Received",
    NotReceive: "Not Receive",
    ReceiveLocation: "Receive Location",
    EnterWordsQuery: "Enter more than 4 words to query",
    EXPQty: "EXP Qty",
    RCVQty: "RCV Qty",
    RCVQtyEA: "RCV Qty EA",
    TOID: "TOID",
    RCVLOC: "RCV LOC",
    EXPIRYDATE: "EXPIRY DATE",
    Descr: "Descr",
    SKU: "SKU",
    UDF1: "UDF1",
    UDF2: "UDF2",
    UDF3: "UDF3",
    ReceiveRequired: "Receive Location - Required",
    RCVQtyCheck: "RCV Qty has to be greater than 0.",
    RCVQtyGtExpQty: "RCV Qty cannot be greater than EXP Qty.",
      Status: "Status",
      Line: "Line#",
      RecDate: "Rec Date",
      LocationCode: "Location Code",
      RecQty: "Rec Qty",
      RecBaseQty: "Rec Base Qty",
      DamageQty: "Damage Qty",
      DamageBaseQty: "Damage Base Qty",
      HoldQty: "Hold Qty",
      HoldBaseQty: "Putaway Base Qty",
      Remarks: "Remarks",
      Desc:"Description",
      ProductType: "Product Type",
      ASNQty: "ASN Qty",
      ASNBaseQty: "ASN Base Qty",
      UOM: "UOM",
      PackageQty: "Package Qty",
      ManufactureDate: "Manufacture Date",
      ExpiryDate: "Expiry Date",
      ShelfDate: "Shelf Date",
      PalletID: "Pallet ID",
      CartonID: "Carton ID",
      TraceID:"Trace ID",
      Article: "Article",
      NotAllowToOverReceive: "Not allow to over receive.",
  },
  reportSetting: {
    DevName: "Dev Name",
    ReSQL: "Re-generate SQL",
    ColumnDetail: "Column Detail",
    ReportType: "Report Type",
    ReportVersion: "Report Version",
    EnglishName: "English Name",
    SimplifiedCNName: "Simplified CN Name",
    TraditionalCNName: "Traditional CN Name",
    EnglishTipsName: "English Tips Name",
    SimplifiedCNTipsName: "Simplified CN Tips Name",
    TraditionalCNTipsName: "Traditional CN Tips Name",
    DisplaySeq: "Display Seq",
    CalculateType: "Calculate Type",
    CustCode: "Cust Code",
    CustName: "Cust Name",
    ProjectCode: "Project Code",
    ProjectName: "Project Name",
    Beautify: "Beautify",
    Verify: "Verify",
    Generate: "Generate",
    Version: "Version",
    Assign: "Assign",
    AssignName: "Assign Name",
    CopyFromMaster: "Copy from Master",
    plInpuSku: "Please input SKU",
    BatchSave: "Batch Save",
    SelectAllforSearchable: "Select All for Search",
    SelectAllforDisaplyable: "Select All for Display",
    importTemplate: "Import Template",
    Upload: "Upload",
    Clone: "Clone",
    importConfig: "Import Config",
    importColumn: "Import Column",
    Mapping: "Mapping",
    Uniquekey: "Unique Key",
    DefaultType: "Default Type",
    DataType: "Data Type",
    Datalength: "Data Length",
    Delimiter:"Delimiter",
    DelimiterDesc:"The default value is'/', 'null' has no separator, and 'Blank' is a space",
    DecimalalPlace: "Decimal Place",
    DateTimeFormat: "Date Time Format",
    StartPosition:"Start Position",
    EndPosition:"End Position",
    ReferenceKey:"Reference Key",
    RangeValue:"Range Value",
    DefaultValue: "Default Value",
    Mandatory: "Mandatory",
    CombineFields: "Combine Fields",
    UploadConfig : "Upload Config",
    FileType:"File Type",
    Delimilter: "Delimilter",
    CloneTemplate: "Clone Template",
    TableColumn: "Table Column",
    OperationRule: "Operation Rule",
    withHeader: "With Header",
    excelStartRow:"Excel start Row#",
    isPrintReport:"Print Report",
    printReportCode:"Print Report Code",
  },
  soPage:{
    PackedFirst:"Not allow to print, please packed first!",
    inputAllQty:"Please enter the Allocate Qty!",
    labelCreateDhlShipmentId: "Create DHL Shipment ID",
    labelAddOrderToShipmentId: "Add Order To Shipment ID",
    labelShipmentReference: "Shipment Reference",
    labelConfirm: "Confirm",
    labelQuery:"Query",
    msgShipmentReferenceIsNull: "Shipment Reference cannot be empty",
  },
  asnPage:{
    mustPutaway:"The status must be Putaway!",
    filesMaxSize:"The total size of the uploaded file should not exceed 500M!",
    UploadPhoto: "Upload Photo",
    saveData:"You haven't changed the data yet!",
    saveHeaderPlease:"Please save the header data first!",
    pleaseSelectTargetProject: "Please select target project.",
    targetProjectNotExist: "Target project not exist!",
    changeWhProjectTitle: "Change WH/Project",
    changeWhProjectLabel: "WH/Project",
  },
  job:{
    Name:"Job Name",
    Class:"Job Class",
    Remark:"Remark",
    Type:"Job Type",
    ParamName:"Parameter Name",
    ParamValue:"Parameter Value",
    Seq:"Seq",
    Add:"Add",
    Save:"Save",
    Run:"Run",
    Delete:"Delete",
    Reset:"Reset",
    Query:"Query",
    Total:"Total",
    Records:"Records",
    notNull:"cannot be empty!",
    Activate:"Activate",
    Inactivate:"Inactivate",
    Action:"Action",
    Status:"Status",
    Expression:"Expression",
    BusinessType:"Business Type",
    StartTime:"Start Time",
    ActionNo:"Action No",
    CreateExpression:"Create Expression",
    DateTime:"Date Time",
    Year:"Year",
    Month:"Month",
    Day:"Day",
    Hour:"Hour",
    Minute:"Minute",
    Second:"Second",
    StatusCanNotDel:"The activate status does not allow delete!",
    ExpressionNotCorrect:"Expression is not correct!",
    TriggerStatus:"Trigger Status",
    PrevFireTime:"Prev Fire Time",
    NextFireTime:"Next Fire Time"
  },
  wine: {
    AvailableQty: "Input Qty is more than Available Qty!",
    inputEnglish:"English input only",
    inputChinese:"Chinese input only",
    maxCharacters:"Max. {0} characters",
    mustInputChinese:"This field is required if there is no English address",
  },
  printLabel:{
    NumberOfQrCodeLabelRequired: "Number of QR Code Label Required",
    NumberOfRelIdLabelRequired: "Number of Rel Id Label Required",
    labelType:"Label Type",
    qrCodeLabel:"Pre-Print Label",
  },
  cfs:{
    OrderCancel:"Order cancelled",
    operationSuccess:"Operation success.",
    orderNo:"Order No",
    loadingNo:"Loading No.",
    platformOrderNo:"Platform Order No",
    parcelNo:"Parcel No",
    unScanQty:"Non-Scan Qty",
    invoiceFlag:"Print Label / Invoice Flag",
    scannedQty:"Scanned Qty",
    parcelNoTrackingNo:"Parcel No. / Tracking No.(Last Mile Label)",
    trackingNo:"Tracking No.(Last Mile Label)",
    destinationCountry:"Destination Country",
    courier:"Courier",
    parcelNotOrder:"Parcel not belong to this order",
    printLabel:"Print Label",
    printDhlInvoice:"Print DHL Commercial Invoice",
    scanLoad:"Scan Load",
    awbMbl:"AWB / MBL / Tracking No",
    uldNo:"Container No. / ULD No.",
    collectionTimeFrom:"Collection Time From",
    collectionTimeTo:"Collection Time To",
    createLoading:"Create Loading",
    confirmLoading:"Confirm Loading",
    ediSendFlag:"EDI Send Flag",
    resetFirst:"Please reset.",
    noOfDestinationLabelRequired:"No. of Destination Label required",
    orderNumber:"Order Number",
    barcode:"Barcode",
    damage:"Damage",
    dimensions:"Dimensions",
    nextOrder:"Next Order",
    delete:"Delete",
    printViewPdf: "Print SSCC label",
  },
  support:{
    org:"Org",
    project:"Project Name",
    a01ReopenASNAsn:"ASN#",
    note:"Note",
    submit:"Submit",
    reset:"Reset",
    c01MovePOToWarehousePO:"PO#",
  },
  printerConfig: {
    refresh:"Refresh",
    servicesName:"Services Name",
    ip:"Ip Address",
    printerName:"Printer Name",
  },
  scanPack:{
    cancelCheckCompleteMsg:'Confirm to remove all packed cartons ?',
    cancelCheckCompleteMoveMsg: 'Auto-move all cancelled stock(s) back to original location?',
    cancelPickForCheckCompleteMsg: 'Below items picked but yet to pack, confirm Cancel Pick the stock(s)?',
    cancelCheckCompleteNo:'No',
    cancelCheckCompleteYes:'Yes',
    title: 'Confirm',
    currentScanQty:'Current Scan Qty',
    deletePickingData:"Confirm to delete the pick data?",
    firstCancelCheckCompleteThenScanPack:"The current order is check completed. Please confirm to cancel check?",
    antiCounterfeitingCodePleaseConfirm:"Anti-counterfeiting codes that are not for outbound delivery. Please confirm.",
    currentBrand:"Current brand",
    getExpressNumber:"Get Express Number",
    ssccAlreadyUse:"SSCC#{0} Mixed packaging orders are not allowed",
    scanByWave:"Please scan with wave#{0}",
    notAllowedBatchClose:"The current packing data has not been submitted, batch closing of boxes is not allowed"
},
skuSearch:{
  skuSearch: "SKU Search",
  upcSearch: "UPC Search",
  sku: "SKU",
  multipleSku: "Multiple SKU",
  skuFrom: "SKU From",
  skuTo: "SKU To",
  search: "Search",
  skuCode: "SKU Code",
  skuDesc: "SKU Desc",
  upc: "UPC",
  style: "Style",
  color: "Color",
  size: "Size"
},
  invTrans:{
    transType:"Type",
    transStatus:"Status",
    orderType:"Type",
    orderNo:"Order No",
    transTimeFrom:"TransTime FM",
    transTimeTo:"TransTime TO",
    systemUser:"System Operator",
    lotAttribute:"Batch attributes",
    ownerCode:"Owner",
    lotNo:"LotNO",
    id:"ID",
    back:"Back",
    transId:"TransactionId",
    transTime:"Transaction Time",
    lineNo:"Line No",
    transactionTime:"Transaction Time must be within {0} days!",
    operator:"Operator",
    ownerCodeFrom:"Owner From",
    ownerCodeTo:"Owner To",
    skuFrom:"SKU From",
    skuTo:"SKU To",
    skuDescFrom:"SKU Desc From",
    skuDescTo:"SKU Desc To",
    lotNoFrom:"lot No From",
    lotNoTo:"lot No To",
    idFrom:"Id From",
    idTo:"Id To",
    locFrom:"Location From",
    locTo:"Location To",
    qtyFrom:"Qty From",
    qtyTo:"Qty To",
    unitQtyFrom:"Qty From (EA)",
    unitQtyTo:"Qty To (EA)",
    uomFrom:"UOM From",
    uomTo:"UOM To",
    descriptionFrom:"Description From",
    descriptionTo:"Description To",
    amount:"Amount",
    typeMustBeSelected:"Type must be selected",
    pleaseSelectAQueryPeriod:"Please select a query period",
  },
  currency:{
    currency:"CURRENCY",
    description:"DESCRIPTION",
    currencySymbol:"CURRENCY SYMBOL",
  },
  billingMaintance:{
    add:"Add",
    query:"Query",
    reset:"Reset",
    edit:"Edit",
    billId:"Bill Id",
    cutOffFrom:"CUT OFF DATE",
    billingPeriodFrom:"BILLING PERIOD FROM",
    billingPeriodTo:"BILLING PERIOD TO",
    confirmDate:"CONFIRM DATE",
    postDate:"POST DATE",
    invoiceNo:"INVOICE NO",
    invoiceDate:"INVOICE DATE",
    billToName:"BILL TO NAME",
    billToAddress1:"ADDRESS 1",
    billToAddress2:"ADDRESS 2",
    billToAddress3:"ADDRESS 3",
    billToAddress4:"ADDRESS 4",
    billToCity:"CITY",
    billToProvince:"PROVINCE",
    billToCountry:"COUNTRY",
    billToZip:"ZIP",
    billToContactName:"CONTACT NAME",
    billToContactPhone:"CONTACT PHONE",
    billToContactFax:"CONTACT FAX",
    billToContactEmail:"CONTACT EMAIL",
    currency:"CURRENCY",
    exchangeRate:"EXCHANGE RATE",
    lineNo:"LINE NO",
    chargeMethod:"CHARGE METHOD",
    tariffId:"TARIFF ID",
    chargeCode:"CHARGE CODE",
    description:"DESCRIPTION",
    billDateFrom:"BILL DATE FROM",
    billDateTo:"BILL DATE TO",
    billType:"BILL TYPE",
    billBase:"BILL BASE",
    billUnit:"BILL UNIT",
    overflowCharge:"OVERFLOW CHARGE",
    accountCode:"ACCOUNT CODE",
    localExchangeRate:"LOCAL EXCHANGE RATE",
    baseAmount:"BASE AMOUNT",
    localAmount:"LOCAL AMOUNT",
    totalAmount:"TOTAL AMOUNT",
    invoiceLineSeq:"INVOICE LINE SEQ",
    CreateMaintance:"Create Maintance",
    EditMaintance:"Edit Maintance",
    PleaseinputBillId:"Please input Bill Id",
    msgBillingPeriodFromLessThanTo:"BILLING PERIOD FROM Less Than BILLING PERIOD TO",

  },
  resPlan:{
    workingDayOnly:"Working Day Only",
    waveIdNotnull:"Wave Id is missing",
    needCreateResourcePlan:"Create Resource Planning?",
  },
  cycleCount:{
    Location:"Location",
    createTicket:"Create Ticket",
    includeStatus:"Include Status",
    reCount:"Re-Count",
    numberOfSplit:"Number of split",
    confirmToCreateTicketForLocation:"Confirm to Create Ticket or Re-Count Location(s) (Include Location[s] Out of Count Record)?",
    confirmToReCountLocation:"Confirm to Re-Count Location(s)?"
  },
  handheldConfiguration:{
    handheldConfiguration:"Handheld Configuration",
    handheldApplicationConfiguration:"Handheld Application Configuration",
    configName:'Config Name',
    relatedFunction:'Related Function',
    status:'Status',
    flowSetting:'Flow Settings',
    orderSearch:'Order Search',
    scanning:'Scanning',
    haveSearchScreen:'Have Search Screen?',
    scanName:'Scan Name',
    promptMessage:'Prompt Message',
    actionSettings:'Action Settings',
    action:'Action',
    targetField:'Target Field',
    field:'Field',
    stepSettings:'Step Settings',
    new: "New",
    value:'Value',
    type:'Type',
    length:'Length',
    dataLength:'Data Length',
    relatedSettings:'Related Settings',
    lockValue:'Lock Value?',
    displayIn:'Display in',
    showCurrProgress:'Show Curr.Progress',
    showSummary:'Show Summary',
    info:'Info',
    showConfDialog:'Show Conf. Dialog',
    displayText:'Display Text',
    changeCommand:'Change Command',
    last:'(Last)',
    completeOnCloseNext:'Complete on Close/Next?',
    suggestLocation:'Suggest Location?',
    dialogSettings:'Dialog Settings',
    input:'Input',
    mandatory:'Mandatory',
    dimension:'Dimension',
    volume:'Volume',
    grossWeight:'grossWeight',
    netWeight:'NetWeight',
    logicSettings:'logic Settings',
    use:'Use',
    priority:'Priority',
    lastLocation:'Last Location',
    nextEmptyLocation:'Next Empty Location',
    pickLocation:'Pick Location',
    storageLocation:'Storage Location',
    closeToSameSku:'Close to Same SKU',
    matchItemType:'Match Item Type',
    useProjectLocation:'Use Project Location',
    useWarehouseLocation:'Use Warehouse Location',
    scanSingle:'Scan Single?',
    displayInformation:'Display Information',
    scanningScanNameCannotBeEmpty:'Scanning {0} Scan Name Cannot be empty.',
    orderSearchScanNameCannotBeEmpty:'OrderSearch Scan Name Cannot be empty.'
  },
  confirmDeleteLoading:"The order has been Loaded,Are you sure to remove it from loading?",
  expDeliveryDateNotnull:"The exp delivery date cannot be empty!",

  printPriceLabel:{
    PageTitle:"Print Price Label",
    PrintAll:"Print All",
    PrintSingle:"Print Single",
    ConsigneeDeliveringTo:"Consignee/Delivering To",
    Copies:"Copies",
    PrintedQty:"Printed Qty",
  },
  cycleCountMaster:{
    belowLocationAndSku:"Below Location and SKU with allocated qty / hold qty, are you sure to ignore them to create count order?",
    quantityNeedsToBeGreaterThan0:"Quantity needs to be greater than 0",
    createCountOrderByNumber:"Create count order by number of default Count?",
    countOrderCompleteOrder:"Count Order {0} and its related Ticket(s) is still in progress! \n" +
        "Do you wish to close the outstandings and complete the Count Master? ",
  },
  scanIn:"Scan In",
  carrier:"Carrier",
  flightNo:"Flight No",
  parcelUnweighed:"Parcel Unweighed.",
  airLine:"Airline",
  arrivedTime:"Arrived Time",
  shipFrom:"Ship From",
  shipTime:"Ship Time",
  services:"Service",
  servicesProvider:"Services Provider",
  gatewayCannotBeEmpty:"Gateway cannot be empty",
  serviceCannotBeEmpty:"Service cannot be empty",
  serviceProviderCannotBeEmpty:"Service Provider cannot be empty",
  skynetPostal:"Skynet Postal",
  battery:"Battery",
  batteryCannotBeEmpty:"Battery cannot be empty",
  copyLoading:"Copy Loading",
  showAll:"Show All",
  loginAccount:"Login Account",
  processActionMsg:"Do you want to process the action?",
  orderRef: "Order Ref",
  printNotConnected: "Printer Not Available!",
  notLabelRecord:"No Record Found!",
  collarBarcode:{
    woolenCollarBarcode:"Woolen collar barcode",
    woolenCollarBarcodeMismatch:"Woolen collar barcode mismatch",
    missing:"missing",
  },
  soStatus:{
    partialAllocated:"Partial Allocated",
    allocation:"Allocated",
    partialPicked:"Partial Picked",
    picked:"Picked",
    partialPacked:"Partial Packed",
    packed:"Packed",
    partialLoaded:"Partial Loaded",
    loaded:"Loaded",
    partialShipped:"Partial Shipped",
    shipped:"Shipped",
    delivered:"Delivered",
    billed:"Billed",
    //closed:"Closed",
    cancelled:"Cancelled",
    deleted:"Deleted",
    closed:"Closed",
  },
  asnStatus:{
    partialReceived:"Partial Received",
    received:"Received",
    partialPutaway:"Partial Putaway",
    putaway:"Putaway",
    cancelled:"Cancelled",
    deleted:"Deleted",
    closed:"Closed",
  },
  loading:{
    loadId:"Load ID",
    container:"Container #",
    hidden: "Hidden",
    searchCartonByWave:"Search Carton by Wave",
    importSscc:"Import SSCC",
    seal:"Seal #",
    containerType:"Container Type",
    vesselFight:"Vessel Fight",
    voyage:"Voyage #",
    mbl:"MBL",
    hbl:"HBL",
    driver:"Driver",
    etd:"ETD",
    eta:"ETA",
    portOfLoading:"Port Of Loading",
    portOfDischarge:"Port Of Discharge",
    portOfDestination:"Port Of Destination",
    loadFrom:"Load From",
    loadTo:"Load To",
    remarks:"Remarks",
    loadedCartonQty:"Loaded Carton Qty",
    loadIdIsEmpty:"Load ID cannot be null",
    detailSearch:"Detail Search",
  },
  filterBy:"Filter By",
  allocationResults:"Allocation Results",
  importResults:"Import Results",
  lastestNotifications:"Latest {0} Notifications",
  todayNotifications:"Today Notifications",
  yesterdayNotifications:"Yesterday Notifications",
  success:"Success",
  failed:"Failed",
  inputNumCharsThenPressEnter:"Input {0} chars then press <enter>",
  queryCondition:"Query Condition",
  thaiName:"Thai Name",
  japaneseName:"Japanese Name",
  headerJoinFieldName:"Header Join Name",
  detailJoinFieldName:"Detail Join Name",
  queryFieldName:"Query Field Name",
  compareType:"Compare Type",
  fixedValue:"Fixed Value",
  pageType:"Page Type",
  codeMasterGroup:"Code Master Group",
  queryTable:"Query Field Table",
  headerTable:"Header Join Table",
  detailTable:"Detail Join Table",
  splitScan: {
    queryConditionCantBeNull: "Query Condition can't be Null",
    skuCannotBeEmpty: "SKU cannot be empty",
    noUnreviewedProductsExist:"Pack Record is Null",
  },
  stdBalanceReport: {
    brand: "Brand",
    size: "Size",
    volume:"Volume m³",
    totalVolume:"Total Volume m³",
    minRecDate: "Original Inbound Time",
    department: "Department",
    sku: "SKU",
    skuName: "SKU Name",
    material: "Material Model No./Code",
    specification: "Specification",
    keyword: "Keyword",
    units: "Units",
    qty: "Quantity",
    inboundTime: "Latest Inbound Time",
    outboundTime: "Latest Outbound Time",
    period: "Period",
    remark: "Remarks/Description",
    Location: "Location",
    prePicture: "Picture Preview"
  },
  // Session modal translations
  sessionModal: {
    title: "Login Expired",
    message: "Session timed out. Please login again",
    passwordChangedMessage: "Password has changed, please login again",
    username: "Username",
    password: "Password",
    loginButton: "Login",
    logoutButton: "Logout",
    usernameRequired: "Please enter username and password",
    passwordRequired: "Please enter password",
    loginFailed: "Login failed, please check username and password",
    loginError: "Login failed, please try again",
    loginSuccess: "Re-login successful",
    loginLoading: "Logging in...",
    loginTimeout: "Request timeout, please try again",
    securityTitle: "Security Alert",
    securityMessage: "Unauthorized data modification detected. Please login again for security.",
    securityWarning: "For your security, please verify your identity",
    tokenExpiredMessage: "Your session has expired. Please log in again.",
    tokenInvalidMessage: "Your authentication token is invalid. Please log in again.",
    noPermissionTitle: "No Permission",
    noPermissionMessage: "You do not have permission to access this resource.",
    okButton: "OK",
    projectChangedTitle: "Project changed",
    projectChangedMessage: "The current project has changed. Refresh the page to load the correct project data.",
    reloadButton: "Refresh",
    reloginButton: "Log in again"
  },
  projectQueryList:"Project Query List",
  defaultQueryList:"Default Query List",
  hide:"Hide",
  show:"Show",
  copyToProjectList:"Copy to Project List",
  copyToAnotherLanguage:"Copy To Another Language",
  copyToAnotherProject:"Copy To Another Project",
  copyTo:"Copy To",
  DueDateUpdateConfirm:"Below Wave already contains Scan Pack Due Date. Confirm to update?",
  domain:"Domain",
  singleSignOn:"Single Sign On",
}
